import Vue from 'vue'
import Vuex from 'vuex'
import VisaSingle from '../store/modules/visa/single'
import CountryForTouristList from './modules/country/list'
import Notification from '../store/modules/notification/notification'
import VisaType from '../store/modules/visa_type';
import Office from '../store/modules/office';
import AirPort from './modules/airport'
import TravellerTrack from './modules/traveller_track'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        VisaSingle,
        CountryForTouristList,
        VisaType,
        Notification,
        Office,
        AirPort,
        TravellerTrack
    }
});

export default store
